// extracted by mini-css-extract-plugin
module.exports = {"root":"CloseButton_root__1q5lc","icon":"CloseButton_icon__3Rgn1"};